<template>
  <div class="user-selector">
    <div class="selector-group">
      <label for="user-select"></label>
      <select 
        id="user-select"
        :value="currentUser" 
        @change="$emit('user-changed', $event.target.value)"
        class="user-select"
      >
        <option v-for="user in users" :key="user.id" :value="user.id">
          {{ user.name }}
        </option>
      </select>
    </div>

  </div>
</template>

<script>
export default {
  name: 'UserSelector',
  props: {
    users: {
      type: Array,
      required: true
    },
    currentUser: {
      type: String,
      required: true
    }
  },
  emits: ['user-changed']
}
</script>

<style scoped>
.user-selector {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.selector-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.selector-group label {
  font-weight: 500;
  white-space: nowrap;
}

.user-select {
  padding: 0.5rem 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1rem;
  min-width: 150px;
  backdrop-filter: blur(10px);
}

.user-select:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.2);
}

.user-select option {
  background: #2c3e50;
  color: white;
}


/* Responsive */
@media (max-width: 768px) {
  .user-selector {
    justify-content: center;
  }
}
</style>
